import compileSymbols from '~/utils/compileSymbols';

var types = [
  'CATEGORY_LOADED',
  'CATEGORY',
  'CATEGORY_FAILED',
  'CATEGORIES_LOADED',
  'CATEGORIES_FAILED',
  'FONT_AUTOFILL_DATA_LOADED',
  'FONT_IS_CLICKED_FROM_DROPDOWN',
  'LOADING_RESULTS',
  'LOAD_FONT_SEARCH_HISTORY',
  'SET_SCROLL_TO_FONT',
  'UPDATE_FONT_SEARCH_HISTORY',
  'UPDATE_PREVIOUS_CATEGORY'
];

export default compileSymbols(types, 'font');
